<template>
    <div>
        <v-card :color="randColor">
            <ChartContainer :chart="chart" @zoom="zoomChart = true" />
        </v-card>
        <v-dialog
            v-model="zoomChart"
            max-width="900px"
        >
            <v-card :color="randColor">
                <ChartContainer :chart="chart" :displayZoom="false" />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import ChartContainer from './ChartContainer.vue'
    export default {
        name: "InformeCard",
        components: {
            ChartContainer
        },
        props: {
            chart: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                zoomChart: false
            }
        },
        mounted(){

        },
        created() {
            
        },
        methods: {
            
        },
        computed: {
            randColor(){
                let colors = [
                    'purple lighten-4', 'deep-purple lighten-4', 'indigo lighten-4', 'blue lighten-4', 'light-blue lighten-4', 'cyan lighten-4', 'teal lighten-4',
                    'green lighten-4', 'light-green lighten-4', 'yellow lighten-4', 'amber lighten-4', 'orange lighten-4', 'deep-orange lighten-4', 'brown lighten-4', 
                    'blue-grey lighten-4'
                ]
                return colors[Math.floor(Math.random() * colors.length)]

            }
        }
    }
</script>
<style>
    
</style>
